export default "__VITE_ASSET__NxM7wp3D__"